<template>
    <div class="stationModal">
        <el-dialog :title="title" :visible="dialogStationVisible" :before-close="beforeClose" width="58%" center>
            <div style="margin-bottom:20px">
                    <span class="fz14 c6 ">{{$t('manipulation.devName')}}：</span>
                    <el-input v-model.trim="projectName" clearable placeholder="" class="handle-input " style="width:160px"></el-input>
                    <el-button type="primary" size="small" class="ml10" icon="el-icon-search" @click="serchinfo">{{$t('tagsView.search')}}</el-button>
                    <el-button type="primary" size="small" class="ml10" icon="el-icon-search" @click="result">{{$t('dataAnalysis.reset')}}</el-button>
            </div>
            <div class="table-content">
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    border
                    @select-all="selectAll"
                     @select="select"
                    row-key="id"
                    style="width: 100%"
                    @selection-change="selectionChange"
                    :tree-props="{children: 'deviceList', hasChildren: 'hasChildren'}"
                    :default-sort="{ prop: 'checkFlag', order: 'descending' }"
                    v-loading="loading"
                >
                    >
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column :label="item.label" :prop='item.prop' :key='index' align="center" v-for='(item,index) in column'>
                        
                    </el-table-column>
                    <!-- <el-table-column label="分配" prop="checkFlag"  align="center">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.checkFlag" @click.native="handleCheckChange(scope.row)"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column prop="gatewayName" label="设备名称" align="center"> </el-table-column>
                    <el-table-column prop="address" label="地址"  align="center"> </el-table-column> -->
                </el-table>
                <!-- <div class="page txtr mt10">
                    <el-pagination
                        background
                        :current-page.sync="param.current"
                        @current-change="handleCurrentChange"
                        layout="total, prev, pager, next"
                        :total="param.total"
                    >
                    </el-pagination>
                </div> -->
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size='small' class="button--cancel" @click="handleClose">{{$t('manipulation.cancel')}}</el-button>
                <el-button size='small' type="primary" @click="handleSubmit">{{$t('manipulation.sure')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getPage, setGateway,distribute } from '@/api/admin/userStation';
import { getProjectAndDeviceList } from '@/api/deviceOverview/alarm';
import { projectPage,projectList } from '@/api/deviceOverview/file';
export default {
    name: 'stationModal',
    props: {
        dialogStationVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
           
        }
    },
    data() {
        return {
            ruleForm: {
                roleName: '',
                roleDesc: '',
                roleCode: ''
            },
            rules: {
                roleName: [{ required: true, message: this.$t('userManage.addRoleName'), trigger: 'blur' }],
                roleDesc: [{ required: true, message: this.$t('userManage.addRoleDes'), trigger: 'blur' }]
            },
            param: {
                current: 1,
                size: 10,
                total:0,
                stationName: '', // 不用
                userId: '', // 获取用户设备和修改时使用
                userStation: [] // int数组,
            },
            
            loading: false,
            tableData: [],
            activeData: [],
            multipleSelection: [],
            column:[
                // {prop:'index',label:'序号'},
                {prop:'projectName',label:this.$t('manipulation.devName')},
               
                {prop:'address',label:this.$t('manipulation.installAddress')},
                {prop:'deviceCount',label:this.$t('manipulation.insNum')},
                {prop:'organization',label:this.$t('realdetile.contUnit')},
                {prop:'installDate',label:this.$t('fileManage.timeSetting')},
                {prop:'devCode',label:this.$t('stationModal.devCode')},
                {prop:'deviceModel',label:this.$t('stationModal.devModel')},
                {prop:'towerNumber',label:this.$t('realtimeinfo.roomNum')},
                {prop:'stairsNumber',label:this.$t('realtimeinfo.eleNum')},
                // {prop:'status',label:'公司名称'},
            ],
            projectName:'',
            wayinfo:'',
           
        };
    },
    created() {
        // this.param.userId = sessionStorage.getItem('stationUserId');
        // this.init();
    },
    mounted() {},
    methods: {
       
         select (selection, row) {
             
            if (selection.some(el => { return row.id === el.id })) {
                if (row.deviceList) {
                row.deviceList.map(j => {
                    this.toggleSelection(j, true)
                })
                }
            } else {
                if (row.deviceList) {
                row.deviceList.map(j => {
                    this.toggleSelection(j, false)
                })
                }
            }
        },
        selectAll (selection) {
        // tabledata第一层只要有在selection里面就是全选
            const isSelect = selection.some(el => {
                const tableDataIds = this.tableData.map(j => j.id)
                return tableDataIds.includes(el.id)
            })
            // tableDate第一层只要有不在selection里面就是全不选
            const isCancel = !this.tableData.every(el => {
                const selectIds = selection.map(j => j.id)
                return selectIds.includes(el.id)
            })
            if (isSelect) {
                selection.map(el => {
                if (el.deviceList) {
                    el.deviceList.map(j => {
                    this.toggleSelection(j, true)
                    })
                }
                })
            }
            if (isCancel) {
                this.tableData.map(el => {
                if (el.deviceList) {
                    el.deviceList.map(j => {
                    this.toggleSelection(j, false)
                    })
                }
                })
            }
        },
        // selectionChange (selection) {
            
        //     console.log(this.selectArr,'selectArr')
        // },
        toggleSelection (row, select) {
            if (row) {
                    this.$nextTick(() => {
                    this.$refs.multipleTable && this.$refs.multipleTable.toggleRowSelection(row, select)
                    })
            }
        },
        init() {
            this.getUserStation();
        },
        serchinfo(){
            this.getUserStation(this.wayinfo)
        },
        result(){
            this.projectName = ''
            this.param.current = 1
            this.getUserStation(this.wayinfo)
        },
        selectionChange(val) {
           
            this.selectArr = val
            let arr = []
            val.map((item,index)=>{
                if(item.projectId){
                  
                    arr.push({projectId:item.projectId,deviceIds:[item.id]})
                }else{
                 
                    arr.push({projectId:item.id,deviceIds:[]})
                }
            })
           
            const hash = Object.create(null)
            const test = arr.filter(function (o) {
                if (!hash[o.projectId]) {
                    hash[o.projectId] = o.deviceIds
                    return true
                }
                Array.prototype.push.apply(hash[o.projectId], o.deviceIds)
            })
            
            test.map((item)=>{
                if(item.deviceIds){
                    item.deviceIds = item.deviceIds.toString()
                }
            })
    
            this.multipleSelection = test;

        },
        getUserStation(val,flag) {
            if (flag) {
                this.param.current = 1
            }
            this.wayinfo = JSON.parse(JSON.stringify(val))
            if(val.deviceListStr){
                this.multipleSelection = JSON.parse(val.deviceListStr)
            }
            
            val.id && (this.param.userId = val.id);
            let obj ={
                projectName:this.projectName,
                ...this.param
            }
            getProjectAndDeviceList(obj).then(res => {
 
                res = res.data.data;
                res.map((item,index)=>{
                    item.index = index +1
                    item.deviceCount = item.deviceList.length
                    if(item.deviceList.length>0){
                        item.deviceList.map((v)=>{
                            v.deviceCount = "——"
                            v.projectId = item.id
                        })
                    }
                })
                this.tableData = res;
                this.$nextTick(()=>{
                     this.tableData.map((item,index) => {
                        
                        val.projectIds&&val.projectIds.split(',').map(v=>{
                            if(item.id ===v){
                                this.$refs.multipleTable.toggleRowSelection(item)
                            }
                        })
                        val.deviceIds&&val.deviceIds.split(",").map((v)=>{
                             if(item.deviceList.length>0){
                                item.deviceList.map(t=>{
                                    if(t.id==v){
                                        this.toggleSelection(t, true)
                                    }
                                })
                            }
                        })
                    });
                })
               
                this.loading = false;
                const { total, pages, current, size } = res;
                // this.param.total =  total;
                // this.param.pages = pages;
                // this.param.current = current;
                // this.param.size =  size ;
            });
        },
        handleCheckChange(val) {
            let checkFlag = !val.checkFlag;
            if (checkFlag) {
                if (!this.isInArray(this.multipleSelection, val.gatewayId)) {
                    this.multipleSelection.push(val.gatewayId);
                    return;
                }
            } else {
                if (this.isInArray(this.multipleSelection, val.gatewayId)) {
                    let index = this.multipleSelection.indexOf(val.gatewayId);
                    this.multipleSelection.splice(index, 1);
                    return;
                }
            }
        },
        // 分页导航
        handleCurrentChange(val) {
            this.param.current = val;
            this.getUserStation();
        },
        // 提交表单
        handleSubmit() {
           
            distribute({userId:this.param.userId,deviceList:this.multipleSelection}).then(res => {
                if (res.data.code === 200) {
                    this.handleClose('0');
                    this.$message.success(this.$t('stationModal.setSuc'));
                } else {
                    this.$message.error(this.$t('stationModal.setFauRepeat'));
                }
            });
        },
        beforeClose(done) {
            this.multipleSelection.length = 0;
            this.param.userStation  = [];
            this.$emit('closeStation');
            done();
        },
        handleClose(num) {
            this.multipleSelection.length = 0;
            this.param.userStation  = [];
            this.$emit('closeStation',num);
        },
        isInArray(arr, value) {
            if (arr.indexOf && typeof arr.indexOf == 'function') {
                var index = arr.indexOf(value);
                if (index >= 0) {
                    return true;
                }
            }
            return false;
        }
    }
};
</script>

<style lang="scss" scoped>
.stationModal {
}
</style>
